"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORGANISATION_STATUS_OPTIONS = exports.WHOS_ORGANISATIONS_OPTIONS = exports.ORGANISATION_TYPE_OPTIONS = void 0;

var _filterFunctions = require("../utils/filterFunctions");

var ORGANISATION_TYPE_OPTIONS = [{
  label: 'All Organisations',
  value: _filterFunctions.ORGANISATION_TYPE_FILTER_MAP.ALL
}, {
  label: 'Draft Only',
  value: _filterFunctions.ORGANISATION_TYPE_FILTER_MAP.DRAFT
}, {
  label: 'New Only',
  value: _filterFunctions.ORGANISATION_TYPE_FILTER_MAP.NEW
}, {
  label: 'Active Only',
  value: _filterFunctions.ORGANISATION_TYPE_FILTER_MAP.ACTIVE
}, {
  label: 'At-Risk Only',
  value: _filterFunctions.ORGANISATION_TYPE_FILTER_MAP.RISK
}];
exports.ORGANISATION_TYPE_OPTIONS = ORGANISATION_TYPE_OPTIONS;
var WHOS_ORGANISATIONS_OPTIONS = [{
  label: 'Everyone\'s Organisations',
  value: _filterFunctions.WHOS_ORGANISATIONS_FILTER_MAP.EVERYONE
}, {
  label: 'Only My Organisations',
  value: _filterFunctions.WHOS_ORGANISATIONS_FILTER_MAP.MINE
}];
exports.WHOS_ORGANISATIONS_OPTIONS = WHOS_ORGANISATIONS_OPTIONS;
var ORGANISATION_STATUS_OPTIONS = [{
  label: 'Active',
  value: 'ACTIVE'
}, {
  label: 'Archived',
  value: 'ARCHIVED'
}];
exports.ORGANISATION_STATUS_OPTIONS = ORGANISATION_STATUS_OPTIONS;